"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section id="hero" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/luxury_residence_roof_pv_panels.png)] bg-cover bg-center animate-[zoom_20s_ease-in-out_infinite_alternate]" />
      
      {}
      <div className="absolute inset-0 surface-overlay" />

      {}
      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center">
        <div className="space-y-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] opacity-100 translate-y-0">
          {}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-display font-bold tracking-tight text-primary leading-tight">
            Maximální ochrana a čistota vaší střechy
          </h1>

          {}
          <p className="text-xl md:text-2xl lg:text-3xl text-foreground font-sans font-light max-w-3xl mx-auto leading-relaxed">
            Profesionální čištění střech, fasád a kompletní realizace fotovoltaických systémů na klíč
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Link to="/ContactPage">
              <Button size="lg" className="btn-primary text-base px-8 py-4 min-w-[200px]">
                Kalkulace zdarma
              </Button>
            </Link>
            <Link to="/ServicesPage" className="hidden">
              <Button size="lg" variant="outline" className="text-base px-8 py-4 min-w-[200px] bg-transparent border-2 border-foreground text-foreground-primary hover:bg-foreground/10 hover:text-foreground-primary hover:border-foreground transition-all duration-[var(--duration-medium)] active:scale-95">
                Naše služby
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes zoom {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.1);
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .animate-\\[zoom_20s_ease-in-out_infinite_alternate\\] {
            animation: none !important;
          }
        }
      `}</style>
    </section>;
}